import(/* webpackMode: "eager", webpackExports: ["default"] */ "/time4news/frontend/components/ReturnBack.jsx");
;
import(/* webpackMode: "eager" */ "/time4news/frontend/node_modules/next/dist/client/link.js");
